'use client'
import { FC, ReactNode, useEffect, useRef } from "react";
import styles from "./styles.module.scss";
import classNames from "classnames";

export interface MyH2Props {
  children: JSX.Element | ReactNode | string;
  className?: string;
}

export const MyH2: FC<MyH2Props> = ({ children, className }) => {
  const h2Ref = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    setTimeout(() => {
      if (h2Ref.current) {
        const el = h2Ref.current;
        const arrayStr = el.innerText.split(" ");
        el.innerHTML = arrayStr
          .map((el, index) => {
            if (index === arrayStr.length - 1) {
              return /* html */ `<span key={${index}} class="h2-container my-h2"><span class="h2-label">${el.trim()}</span></span>`;
            }
            return el.trim();
          })
          .join(" ");
      }
    }, 500);
  }, []);

  return (
    <h2 className={classNames(styles.my_h2, className)} ref={h2Ref}>
      {children}
    </h2>
  );
};
